export const SEARCH_FORM_SUBMIT = 'RECORD.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'RECORD.SORT_CHANGE';
export const PAGE_CHANGE = 'RECORD.PAGE_CHANGE';
export const FETCH_LIST = 'RECORD.FETCH_LIST';
export const FETCH_ONE = 'RECORD.FETCH_ONE';
export const CLEAR_ONE = 'RECORD.CLEAR_ONE';
